import { render } from "./InstanceDetails.vue?vue&type=template&id=b1815116&scoped=true"
import script from "./InstanceDetails.vue?vue&type=script&lang=js"
export * from "./InstanceDetails.vue?vue&type=script&lang=js"

import "./InstanceDetails.vue?vue&type=style&index=0&id=b1815116&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1815116"]])

export default __exports__